import { render, staticRenderFns } from "./YoutubeSlide.vue?vue&type=template&id=2bde9b30&"
import script from "./YoutubeSlide.vue?vue&type=script&lang=js&"
export * from "./YoutubeSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports